// extracted by mini-css-extract-plugin
export var wrapper = "Quotes-module--wrapper--30PjV";
export var inner = "Quotes-module--inner--KfooV";
export var heading = "Quotes-module--heading--cM8KP";
export var quotes = "Quotes-module--quotes--1LNE-";
export var quote = "Quotes-module--quote--3ejFH";